<div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}: {{liveVersion.version}}</h4>
</div>
<div class="modal-body">
    <div>
        <div class="alert alert-warning" *ngIf="closeBtnName === 'Reload'">An update is available and a reload is required. Please click the button below to continue.</div>
        <div class="alert alert-info" *ngFor="let update of liveVersion.updates">
            <span *ngIf="update.indexOf('/') != 0">{{update}}</span>
            <img class="img-fluid rounded" *ngIf="update.indexOf('/') === 0" [src]="update"/>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="onConfirm()">{{closeBtnName}}</button>
</div>